/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ButtonTheme*`'s.
 */
export type ButtonTheme = ButtonThemeDefault | ButtonThemePrimary | ButtonThemeSuccess | ButtonThemeDanger;

/**
 * The Button default theme type.
 */
export type ButtonThemeDefault = typeof BUTTON_THEME_DEFAULT;

/**
 * The Button primary theme type.
 */
export type ButtonThemePrimary = typeof BUTTON_THEME_PRIMARY;

/**
 * The Button success theme type.
 */
export type ButtonThemeSuccess = typeof BUTTON_THEME_SUCCESS;

/**
 * The Button danger theme type.
 */
export type ButtonThemeDanger = typeof BUTTON_THEME_DANGER;

/**
 * The Button default theme constant.
 */
export const BUTTON_THEME_DEFAULT = `default`;

/**
 * The Button primary theme constant.
 */
export const BUTTON_THEME_PRIMARY = `primary`;

/**
 * The Button success theme constant.
 */
export const BUTTON_THEME_SUCCESS = `success`;

/**
 * The Button danger theme constant.
 */
export const BUTTON_THEME_DANGER = `danger`;
